import React from 'react';
import ReactDOM from 'react-dom';

class Props {
	x: number;
	y: number;
	id: string;
	className?: string;
	onHovered?: () => void;
	onMouseLeave?: () => void;
	children?: any;
}

export class CursorTooltip extends React.PureComponent<Props> {
	private ref: React.RefObject<HTMLDivElement> = React.createRef();

	public override componentDidMount() {
		const elementRef = this.ref.current;
		if (elementRef) {
			elementRef.addEventListener('mouseenter', (e) => this.props.onHovered && this.props.onHovered());
			elementRef.addEventListener('mouseleave', (e) => this.props.onMouseLeave && this.props.onMouseLeave());
		}
	}

	public override render() {
		return ReactDOM.createPortal(<div id={this.props.id} ref={this.ref}
										  className={`tooltip fade in on-hover-tooltip ${this.props.className ? this.props.className : ''}`}
										  style={{
											  top: this.props.y,
											  left: this.props.x,
										  }}>
			<div className='tooltip-inner'>{this.props.children}</div>
		</div>, document.body);
	}
}
